import gql from 'graphql-tag';

// Comments v3 (plan 1): the author changes the own text.
export default gql`
mutation updatePageComment($commentId: Int!, $body: String!, $editedAt: timestamptz!) {
  update_page_comments_by_pk(pk_columns: {comment_id: $commentId}, _set: {body: $body, edited_at: $editedAt}) {
    comment_id
  }
}
`;
